import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgArrowLeftCircle = function SvgArrowLeftCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12ZM12.5 3.5C7.80558 3.5 4 7.30558 4 12C4 16.6944 7.80558 20.5 12.5 20.5C17.1944 20.5 21 16.6944 21 12C21 7.30558 17.1944 3.5 12.5 3.5ZM12.3696 8.1661C12.6625 8.45899 12.6625 8.93387 12.3696 9.22676L10.3464 11.25H16.4643C16.8785 11.25 17.2143 11.5858 17.2143 12C17.2143 12.4142 16.8785 12.75 16.4643 12.75H10.3464L12.3696 14.7732C12.6625 15.0661 12.6625 15.541 12.3696 15.8339C12.0767 16.1268 11.6018 16.1268 11.309 15.8339L8.00538 12.5303C7.86473 12.3897 7.78571 12.1989 7.78571 12C7.78571 11.8011 7.86473 11.6103 8.00538 11.4697L11.309 8.1661C11.6018 7.87321 12.0767 7.87321 12.3696 8.1661Z"
  })));
};

export { SvgArrowLeftCircle as ReactComponent };
//# sourceMappingURL=arrow-left-circle.svg.js.map
